import { Token } from './Authentication.gql';

// Define the token
let theToken: Token;

export const setToken = (token: Token): void => {
  theToken = token;
};

export const getToken = (): Token => {
  return theToken;
};

/**
 * Define the API here
 */
